/**
 * Build-level constants for outbound endpoints and build identity.
 *
 * `__DEFAULT_API_BASE_URL__` is injected by esbuild `define`; the tracker base
 * URLs live here (not in the config normalizer) so every hardcoded endpoint is
 * in one place.
 */

export const DEFAULT_API_BASE_URL: string = __DEFAULT_API_BASE_URL__;

/**
 * Semver plus the commit built from, e.g. `sdk-0.1.0-a1b2c3d`. Identifies the
 * bundle, so it is both `KueezSDK.version` and the `yv` on every event. Always
 * lowercase — see `esbuild.config.mjs`.
 *
 * Deliberately not hex: the consumer's `/fpd` route treats `yv` as a hex seed
 * (`Long.decode("0x" + yv)`), which only holds because the SDK calls `/dye` and
 * `/p` and nothing else. Adding an `/fpd` call means revisiting this value.
 */
export const SDK_VERSION: string = __SDK_VERSION__;

/** First-party `/dye` tracker fanout targets. */
export const TRACKER_BASE_URLS: readonly string[] = [
  'https://track.kueez.net',
  'https://gtrack.kueez.net',
  'https://otrack.kueez.net',
];
